/**
 * - Added `AccountBreadcrumbs` to the `first` slot
 */

import { Layout } from '@/data/types/Layout';

export const getOrderDetailsPage = (): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'AccountBreadcrumbs', id: 'account-breadcrumbs' }],
		second: [{ name: 'OrderHistoryDetails', id: 'order-history-details' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
